import GetResultadosC3 from '../../modules/resultado-c3/application/GetResultadosC3'
import ResultadoC3ApiRepository from '../../modules/resultado-c3/infrastructure/ResultadoC3ApiRepository'

export default {
    namespaced: true,

    state: {
        resultados: [],
        resultadoC3: {
            id: 0,
            fecha: '',
            resultado: '',
            observaciones: '',
        },
        selectedResultadoC3: null,
    },

    getters: {
        getResultadosC3: state => state.resultados,
        getSelectedResultadoC3: state => {
            return state.selectedResultadoC3
        },
    },

    mutations: {
        SET_RESULTADOS_C3(state, resultados) {
            state.resultados = resultados
        },
        SET_SELECTED_RESULTADO_C3(state, resultados) {
            state.selectedResultadoC3 = { ...resultados }
        },
    },

    actions: {
        async fetchResultadosC3({ commit }) {
            const resultados = await new GetResultadosC3(new ResultadoC3ApiRepository()).execute()
            commit('SET_RESULTADOS_C3', resultados)
        },
    },
}
